// ProfileTab.js
import { connect } from 'react-redux';
import { replace } from 'redux-first-history';

import ProfileTab from '../component/ProfileTab.jsx';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { USER_PROFILE_TABS } from '../RemoteConfigKeys.js';

const mapStateToProps = state => {
  return {
    profileTabs: getRemoteConfigData(state, USER_PROFILE_TABS),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    replace: ({ pathname }) => dispatch(replace(pathname)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileTab);
